import http from '../utils/request'

export const getAllTenants = () => http.get('/tenant/all')
export const getTenant = (guid) => http.get(`/tenant/${guid}`)
export const createTenant = (data) => http.post('/tenant', data)
export const updateTenant = (guid, data) => http.put(`/tenant/${guid}`, data)
export const deleteTenant = (guid) => http.delete(`/tenant/${guid}`)
export const toggleTenantStatus = (guid) => http.put(`/tenant/${guid}/toggle-status`)
